/*
 * Copyright (C) 2021 to Present Applause App Quality, Inc. All rights reserved.
 */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, signal } from '@angular/core';

@Component({
    selector: 'ngf-avatar-image',
    templateUrl: './avatar-image.component.html',
    styleUrls: ['./avatar-image.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AvatarImageComponent {
  @Input()
  public userId!: number;

  @Input()
  public size: 'xs' | 's' = 'xs';

  @Output()
  avatarLoaded = new EventEmitter();

  @Output()
  avatarError = new EventEmitter();

  loadError = signal(false);

  constructor(private cdr: ChangeDetectorRef) {}

  public refresh(): void {
    this.loadError.set(false);
    this.cdr.markForCheck();
  }

  onImageLoad() {
    this.loadError.set(false);
    this.avatarLoaded.emit();
  }

  onImageError() {
    this.loadError.set(true);
    this.avatarError.emit();
  }
}
